<app-scroll-top></app-scroll-top>
<div class="about-us-page min-h-50">
  <div class="slider-bg-img gradient01 ">
    <div class="container">
      <nav class="py-4">
        <ol itemscope itemtype="http://schema.org/BreadcrumbList" class="breadcrumb breadcrumb-arrow breadcrumb-tdm mb-0">
          <li itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem" class="breadcrumb-item fw-semibold"><meta itemprop="position" content="1">
            <a itemprop="item" [routerLink]="['/accueil']" role="button" routerLinkActive="router-link-active"><span itemprop="name">Accueil</span></a></li>
          <li itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem" class="breadcrumb-item active" aria-current="page"><meta itemprop="position" content="2"><span itemprop="name">By TDM</span></li>
        </ol>
      </nav>
      <div class="row row-cols-md-2 row-cols-sm-1 ">
        <div class="slider-txt py-md-2 py-sm-2">
          <div class="h-100">
            <img width="1238" height="582" src="assets/logo/logo_bytdm_signature_blanc.png" class="logo-bytdm" alt="by TDM">
            <h1 class="headingBytdm  py-md-2 py-sm-2"><span style="color : #BADFFF">LA SOLUTION IMMOBILIÈRE AUGMENTÉE </span></h1>
            <h4>Votre agence. Votre marque.<br/>Un écosystème pour aller plus loin.</h4>
            <h6 class="description">By TDM accompagne les agences immobilières indépendantes avec une solution complète : logiciel métier, diffusion, formation, accompagnement commercial et appui réglementaire.</h6>
            <h6 class="description">Gardez votre indépendance, profitez de la puissance d'un réseau et développez votre performance.</h6>
            <div class=" py-md-2 py-sm-1">
            <a [href]="outlookBookingUrl" target="_blank" rel="noopener" class="btn btn-gold mx-1">
              Découvrir l’écosystème By TDM
            </a>
            </div>
          </div>
          <div>
          </div>
        </div>
        <div class="slider-img" style="display: flex; align-items: flex-end;">
          <img width="575" height="570" style="border-radius: 50% 50% 0% 0%;"
               src="assets/resources/web/images/data/photo_agence_immobiliere_by_TDM.png" alt="by TDM">
        </div>
      </div>
    </div>
  </div>

  <div class="about-us-bloc py-4 py-md-5">
    <div class="container content">
      <div class="formulaireBytdm text-start">
        <div class="row row-cols-1 row-cols-md-3 text-center">
          <div class="col">
            <strong>Votre identité préservée</strong><br/>Votre marque et votre implantation locale
          </div>
          <div class="col">
            <strong>Un écosystème complet</strong><br/>Des outils et un accompagnement pour votre équipe
          </div>
          <div class="col">
            <strong>Des moyens adaptés</strong><br/>Deux formules de diffusion et une rémunération dégressive
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="bloc-ami" id="en-savoir-plus">
    <div class="container pb-4">
      <div class="row py-3">
        <h3 class="text-uppercase">POURQUOI REJOINDRE <span class="bleutdm">BY TDM</span> ?
        </h3>
      </div>
      <div class="row row-cols-md-2 row-cols-sm-1 py-3">
        <div class="text-end">
          <img width="651" height="537" src="assets/resources/web/images/data/pourquoi_rejoindre_tdm.png" class="img-fluid"
               alt="POURQUOI REJOINDRE BY TDM ?">
        </div>
        <div class="align-self-md-center mt-2 mt-md-0">
          <p>
            <span class="bullet">✓ </span><span class="txt-gras">Conservez votre marque et votre ancrage local</span> qui font la force de votre agence.
            <br/><span class="bullet">✓ </span><span class="txt-gras">Gagnez du temps au quotidien</span> grâce à des outils métier réunis dans un même écosystème.
            <br/><span class="bullet">✓ </span><span class="txt-gras">Structurez votre activité</span> avec des procédures et un appui réglementaire.
            <br/><span class="bullet">✓ </span><span class="txt-gras">Adaptez votre diffusion à vos besoins</span> avec les formules Essentielle et Intégrale.
            <br/><span class="bullet">✓ </span><span class="txt-gras">Concentrez votre énergie sur vos clients et vos ventes</span> en vous appuyant sur les moyens de THE DOOR MAN.
          </p>
          <p class="parole-pam">“La solution immobilière augmentée a été pensée pour révéler tout le potentiel des agences immobilières” <br/>Pierre Arnaud MAZZANTI</p>
          <div class="pt-5">
            <a
              [href]="outlookBookingUrl"
              target="_blank"
              rel="noopener"
              class="btn btn-primary text-white mx-1">
              En savoir plus
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="infrastructure-bloc">
    <div class="container py-5">
      <h3 class="infra-title text-center text-uppercase">
        Une infrastructure de performance<br/>
        <span style="color : #BADFFF">au service des agences immobilières</span>
      </h3>
      <div class="row row-cols-1 row-cols-md-3 g-4 py-4">
        <div class="col">
          <div class="card-infra">
            <img width="512" height="512" src="assets/resources/web/picto-bytdm/moteur-de-recherche.png" class="w-25 h-auto" alt="by TDM : Outils digitaux métiers">
            <h4>Outils digitaux métiers</h4>
            <p>Logiciels de transaction et de suivi des mandats, estimation immobilière et data marché : des solutions professionnelles partagées.</p>
          </div>
        </div>
        <div class="col">
          <div class="card-infra card-infra-light">
            <img width="512" height="512" src="assets/resources/web/picto-bytdm/site-internet.png" class="w-25 h-auto" alt="by TDM : Diffusion automatisée">
            <h4>Diffusion automatisée</h4>
            <p>Diffusion mutualisée de vos annonces sur les principaux portails immobiliers. Plus de visibilité, moins de coûts unitaires.</p>
          </div>
        </div>
        <div class="col">
          <div class="card-infra">
            <img width="512" height="512" src="assets/resources/web/picto-bytdm/contracter.png" class="w-25 h-auto" alt="by TDM : Dématérialisation & signature">
            <h4>Dématérialisation &amp; signature</h4>
            <p>Solutions de dématérialisation complète des dossiers et signature électronique intégrée à vos process métiers.</p>
          </div>
        </div>
        <div class="col">
          <div class="card-infra card-infra-light">
            <img width="512" height="512" src="assets/resources/web/picto-bytdm/conversation.png" class="w-25 h-auto" alt="by TDM : Assistance & juridique">
            <h4>Assistance juridique</h4>
            <p>Accompagnement réglementaire, technique et juridique pour sécuriser votre activité sans nécessiter un département dédié.</p>
          </div>
        </div>
        <div class="col">
          <div class="card-infra">
            <img width="512" height="512" src="assets/resources/web/picto-bytdm/commercialisation.png" class="w-25 h-auto" alt="by TDM : Communication & marque">
            <h4>Communication &amp; marque</h4>
            <p>Outils et accompagnement pour renforcer votre attractivité locale, adossée à la notoriété nationale THE DOOR MAN.</p>
          </div>
        </div>
        <div class="col">
          <div class="card-infra card-infra-light">
            <img width="512" height="512" src="assets/resources/web/picto-bytdm/accord.png" class="w-25 h-auto" alt="by TDM : Parcours sécuritaire">
            <h4>Parcours sécuritaire</h4>
            <p>TRACFIN, RGPD et obligations réglementaires intégrés dans vos outils pour sécuriser votre activité et vous concentrer sur votre développement.</p>
          </div>
        </div>
      </div>
      <div class="text-center pt-3">
        <a [href]="outlookBookingUrl" target="_blank" rel="noopener" class="btn btn-light btn-infra">
          Prendre rendez-vous
        </a>
      </div>
    </div>
  </div>

  <div class="projet-porte-bloc">
    <div class="container py-5">
      <div class="row  align-items-center g-5">
        <div class="col">
          <h3 class="text-uppercase">Un projet porté par</h3>
          <h3 class="text-uppercase text-black">Des professionnels expérimentés</h3>
          <p class="text-black">
            by TDM est né de l'alliance entre une vision entrepreneuriale de long terme et une expertise métier de terrain irréprochable.
          </p>
        </div>
      </div>
      <div class="row row-cols-1 row-cols-md-2 align-items-center g-5">
        <div class="col">
          <div class="projet-card">
            <div class="projet-card-label">Fondateur de The Door Man - expert réseaux</div>
            <div class="projet-card-title">Pierre Arnaud MAZZANTI</div>
            <p>Professionnel du développement de réseaux immobiliers et des modèles économiques, Pierre Arnaud Mazzanti
              accompagne depuis de nombreuses années les entrepreneurs du secteur dans leur croissance et l’optimisation de leur organisation.</p>
            <p>Son expertise porte notamment sur la performance opérationnelle, la mutualisation des ressources et les solutions innovantes.</p>
          </div>
          <div class="projet-card">
            <div class="projet-card-label">Groupe associé</div>
            <div class="projet-card-title">Famille Beuvelet – BGI Holding</div>
            <p>
              Détenue à 100 % par la famille Beuvelet, BGI est une Holding animatrice de groupe.
              <br/>Elle intervient depuis plus de 50 ans dans le crédit, l'immobilier et l'assurance.
              <br/>Cette expérience entrepreneuriale de long terme garantit à By TDM un modèle, juridiquement et économiquement performant.
            </p>
          </div>
        </div>

        <div class="col">
          <img width="1540" height="1920" src="assets/resources/web/images/data/Photo-PAM-Pascal.webp"
               class="img-fluid projet-photo"
               alt="Pierre Arnaud Mazzanti et Pascal Beuvelet">
        </div>
      </div>
    </div>
  </div>

  <div class="temoignages-bloc">
    <div class="container py-5">
      <h2 class="temoignages-title text-center text-uppercase">Ils en parlent mieux que nous</h2>
      <p class="temoignages-intro text-center">
        Dirigeants d'agences, entrepreneurs immobiliers, licenciés by TDM... découvrez leurs retours d'expérience
        <br/>et comment THE DOOR MAN a transformé leur quotidien, leur rentabilité et leur liberté d'action.
      </p>
      <div class="temoignages-carousel">
        <!-- role="group" : voir card-bien — aria-activedescendant, posé par ngb-carousel,
             n'est autorisé que sur certains rôles. -->
        <ngb-carousel [interval]="10000" [pauseOnHover]="true" [showNavigationIndicators]="false" [showNavigationArrows]="true"
          role="group" aria-roledescription="carrousel" aria-label="Témoignages">
          <ng-template ngbSlide *ngFor="let groupe of temoignagesGroupes; let i = index">
            <div class="row row-cols-1 row-cols-lg-3 g-4 temoignages-row">
              <div class="col" *ngFor="let t of groupe">
                <div #temoignageCard
                     class="temoignage-card"
                     [style.height.px]="temoignageCardHeight || null">
                  <div class="temoignage-header">
                    <img [src]="t.avatar"
                         class="temoignage-avatar"
                         [alt]="t.nom"
                         (load)="scheduleTemoignageCardsHeightUpdate()">
                    <div>
                      <div class="temoignage-nom">{{ t.nom }}</div>
                      <div class="temoignage-region">{{ t.region }}</div>
                    </div>
                  </div>
                  <p class="temoignage-text pt-4">{{ t.texte }}</p>
                </div>
              </div>
            </div>
          </ng-template>
        </ngb-carousel>
      </div>
      <div class="text-center pt-4">
        <a [href]="outlookBookingUrl" target="_blank" rel="noopener" class="btn btn-gold">
          Obtenir une présentation par Pierre Arnaud Mazzanti
        </a>
      </div>
    </div>
  </div>

  <div class="faq-bloc py-5">
    <div class="container content">
      <div class="my-5">
        <div class="text-uppercase my-3">
          <h2><span style="color : #013C7D">Avant de prendre RDV avec le fondateur,</span>
            <br/>voici l’essentiel à savoir</h2>
        </div>
        <div ngbAccordion [closeOthers]="true">

          <div *ngFor="let faq of faqs; let i = index"
               [id]="convertIdForAncre(faq.question)"
               [ngbAccordionItem]="'faq-' + i">

            <h2 ngbAccordionHeader>
              <button ngbAccordionButton>
                {{ faq.question }}
              </button>
            </h2>

            <div ngbAccordionCollapse>
              <div ngbAccordionBody>
                <div [innerHTML]="faq.reponse"></div>
              </div>
            </div>

          </div>

        </div>
      </div>
<!--      <div class=" text-center">-->
<!--        <a [routerLink]="['/faq-the-door-man.html']" fragment="by-tdm"-->
<!--           class="link-list-item fw-semibold pb-1">-->
<!--          Voir toutes les questions-->
<!--        </a>-->
<!--      </div>-->
    </div>
  </div>
    <div class="optimiser-bloc">
      <div class="container py-5 text-center">
        <h2 class="mb-5 text-uppercase">Prêt à nous rejoindre</h2>
        <p>Rejoignez la licence by TDM spécifiquement crée pour les Agents Immobiliers libres, exigeants et responsables.</p>

        <div class="advantages-list">
          <div class="advantage-item">Indépendance totale</div>
          <div class="advantage-item">Tracfin/RGPD sécurisé</div>
          <div class="advantage-item">Coûts optimisés</div>
          <div class="advantage-item">Sans franchise</div>
        </div>

        <a
          [href]="outlookBookingUrl"
          target="_blank"
          rel="noopener"
          class="btn contact-btn"
        >
          PRENDRE CONTACT AVEC PIERRE ARNAUD MAZZANTI
        </a>
    </div>
  </div>
</div>
